import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const { currentSession } = this.authService;
    const isAuthEndpoint = req.url.includes('/auth/');
    const authReq =
      currentSession?.accessToken && !isAuthEndpoint
        ? req.clone({ setHeaders: { Authorization: `${currentSession.tokenType} ${currentSession.accessToken}` } })
        : req;

    return next.handle(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && !isAuthEndpoint) {
          return this.authService.initSession(true).pipe(
            switchMap((session) => {
              const retryReq = req.clone({
                setHeaders: { Authorization: `${session.tokenType} ${session.accessToken}` },
              });
              return next.handle(retryReq);
            }),
          );
        }

        return throwError(() => err);
      }),
    );
  }
}
